import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import apis from '../../services/apis';
import $ from 'jquery';
import { toast } from "react-toastify";
import apiUrls from '../../constants/apiUrls';
import { customFormDataPost } from '../../helper/api-helper/apiHerlpers';
import apiCommonParams from '../../constants/apiCommonParams';
import './feature.css';
import AppContext from "../../Context/AppContext";

class AddFeature extends React.Component {
    static contextType = AppContext;
constructor(props) {
    super(props);

    let featureModel = {
        id: 0,
        name: "",
        description: "",
        status: "",
        projectId: "",
        priority: 1,
        colorCode: ""
    };

   
    if (props.featureDetail?.json) {
        const feature = JSON.parse(props.featureDetail.json);

        featureModel = {
            id: feature.featureId || 0,
            name: feature.title || "",
            description: feature.description || "",
            status: feature.status || "",
            projectId: feature.projectId || "",
            priority: feature.priority || 1,
            colorCode: feature.colorCode || ""
        };
    }

    let header_data = {
        masterProjectId: 0,
        masterReleaseId: 0,
        masterUserId: 0,
        featureId: 0,
        filterStartDate: 0,
        filterEndDate: 0
    };

    if (props.header_data) {
        header_data = { ...header_data, ...props.header_data };
    }

    
    if (featureModel.id) {
        header_data.featureId = featureModel.id;
    }

    this.state = {
        projects: [],
        featureStatusList: [],
        featureModel,
        header_data,
        userId: props.userId,
        isAdmin: props.isAdmin,
        submitted: false
    };

    this.saveFeature = this.saveFeature.bind(this);
    this.deleteFeatureById = this.deleteFeatureById.bind(this);
}


    async componentDidMount() {
    const storedToken = localStorage.getItem('keycloakToken');
    const { applicationId, siteId } = this.context;

    const projects = await apis.getProjects(
        applicationId, siteId,
        this.state.userId,
        this.state.isAdmin,
        storedToken
    );

    const projectPermissions = JSON.parse(localStorage.getItem("projectPermissions")) || {};
    const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;

    const filteredProjects = isGlobalAdmin
        ? projects
        : projects.filter(p => {
            const perms = projectPermissions[p.value] || [];
            return perms.includes("AF"); // Only include projects where user has Add Feature permission
        });

    console.log("Filtered Projects:", filteredProjects);

    this.setState({
        projects: filteredProjects,
        featureStatusList: apis.featureStatusList
    });
}




    
    hideValidationMessagesIfValid() {
        $('#addFeatureForm .required-field').each(function () {
            let value = "";

            if ($(this).hasClass("form-control")) {
                value = $(this).val();
            } else if ($(this).hasClass("p-dropdown")) {
                value = $(this).find('.p-dropdown-label').text().trim();
            }

            if (value && value !== "-Select status-" && value !== "-Select project-") {
                $(this).closest('.form-group').find('.form-error.required').hide();
            }
        });
    }

    async saveFeature() {
        const storedToken = localStorage.getItem('keycloakToken');
        const { applicationId, siteId } = this.context;

        this.setState({ submitted: true });

        
        let isValid = true;
        $('#addFeatureForm .required-field').each(function() {
            let value = "";
            if ($(this).hasClass("form-control")) {
                value = $(this).val();
            } else if ($(this).hasClass("p-dropdown")) {
                value = $(this).find('.p-dropdown-label').text().trim();
            }

            if (!value || value === "-Select status-" || value === "-Select project-") {
                isValid = false;
                $(this).closest('.form-group').find('.form-error.required').show();
            } else {
                $(this).closest('.form-group').find('.form-error.required').hide();
            }
        });

        if (!isValid) return;

        const btn = $('#btnAddFeature');
        btn.attr('disabled', 'disabled').text('Please wait...');

        const { featureModel } = this.state;
        const featureData = {
            featureId: featureModel.id,
            title: featureModel.name,
            description: featureModel.description,
            projectId: featureModel.projectId,
            status: featureModel.status,
            applicationId: applicationId,
            siteId: siteId,
            userCreated: apiCommonParams.userid,
            userModified: apiCommonParams.userid,
            createdTime: new Date().getTime(),
            updatedTime: new Date().getTime(),
            priority: featureModel.priority,
            colorCode: featureModel.colorCode
        };

        const form_data = new FormData();
        form_data.append('feature', JSON.stringify(featureData));
        form_data.append('swcmTicket', apiCommonParams.swcmTicket);
        form_data.append("userid", this.props.userId);

        const result = await customFormDataPost(apiUrls.saveFeature, form_data, storedToken);

        btn.removeAttr('disabled').text('SUBMIT');

        if (result?.code === "Success") {
           const projectId = this.state.featureModel.projectId;
    const featureId = this.state.featureModel.id; // edited feature

    if (this.props.loadMasterFeatureDdl && projectId) {
        this.props.loadMasterFeatureDdl(projectId, featureId);
    }
            this.props.hideFeature(false, null, this.props.header_data, true);
            toast.success(
                featureModel.id === 0
                    ? 'Feature created successfully!'
                    : 'Feature updated successfully!',
                { position: toast.POSITION.TOP_RIGHT }
            );
        } else {
            toast.error('Something went wrong, please try again later!', { position: toast.POSITION.TOP_RIGHT });
        }

        
        this.setState({
            featureModel: { id: 0, name: "", description: "", status: "", projectId: "", priority: 1, colorCode: "" },
            submitted: false
        });
    }

async deleteFeatureById() {
  const storedToken = localStorage.getItem('keycloakToken');
  const { applicationId, siteId } = this.context;
  if (!this.state.featureModel.id) return;

  if (!window.confirm('Are you sure you want to delete this feature?')) return;

  const btn = $('#btnDeleteFeature');
  btn.attr('disabled', true).text('Please wait...');

  const formData = new FormData();
  formData.append('featureid', this.state.featureModel.id);
  formData.append('applicationid', applicationId);
  formData.append('siteid', siteId);
  formData.append('swcmTicket', apiCommonParams.swcmTicket);
  formData.append("userid", this.props.userId);

  const result = await customFormDataPost(
    apiUrls.deleteFeature,
    formData,
    storedToken
  );

  btn.removeAttr('disabled').text('Delete Feature');

  if (result?.code === "Success") {
     if (this.props.loadMasterFeatureDdl && this.props.header_data?.masterProjectId) {
        this.props.loadMasterFeatureDdl(this.props.header_data.masterProjectId);
    }
  this.props.hideFeature(false, null, this.props.header_data, true);

  this.setState({
    featureModel: {
      id: 0,
      name: "",
      description: "",
      status: "",
      projectId: "",
      priority: 1,
      colorCode: ""
    },
    submitted: false
  });

  toast.success("Feature deleted successfully!", {
    position: toast.POSITION.TOP_RIGHT
  });
} else {
  toast.error("Something went wrong!", {
    position: toast.POSITION.TOP_RIGHT
  });
}
}

   componentDidUpdate(prevProps) {
  
  if (
    this.props.featureDetail !== prevProps.featureDetail &&
    this.props.featureDetail?.json
  ) {
    const feature = JSON.parse(this.props.featureDetail.json);

    this.setState({
      featureModel: {
        id: feature.featureId || 0,
        name: feature.title || "",
        description: feature.description || "",
        status: feature.status || "",
        projectId: feature.projectId || "",
        priority: feature.priority || 1,
        colorCode: feature.colorCode || ""
      }
    });
  }

 
  if (
    prevProps.featureDetail &&
    !this.props.featureDetail
  ) {
    this.setState({
      featureModel: {
        id: 0,
        name: "",
        description: "",
        status: "",
        projectId: "",
        priority: 1,
        colorCode: ""
      },
      submitted: false
    });
  }
}



    render() {
        const { featureModel, projects, featureStatusList } = this.state;
        const isGlobalAdmin = JSON.parse(localStorage.getItem("isGlobalAdmin")) || false;
    const projectPermissions = JSON.parse(localStorage.getItem("projectPermissions")) || {};

    const projectId = featureModel.projectId;

    const projectPerms = projectPermissions[projectId] || [];

    const canEditFeature =
        isGlobalAdmin || projectPerms.includes("EF");

    const canDeleteFeature =
        isGlobalAdmin || projectPerms.includes("DF");

        return (
            <div className="form-sec shadow-lg add-form-sec">
                <div className="form-blog w-100 float-left position-relative">
                    <span onClick={() => { this.props.hideFeature(false, null, this.state.header_data) }} className="close-form-icon">
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </span>
                    <h2>{featureModel.id === 0 ? "Add New Feature" : "Edit Feature"}</h2>
                    <form id="addFeatureForm" className="frm">

                        {/* Name */}
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control required-field"
                                value={featureModel.name}
                                onChange={e => {
                                    this.setState({ featureModel: { ...featureModel, name: e.target.value } });
                                    this.hideValidationMessagesIfValid();
                                }}
                            />
                            <span className="form-error required text-danger" style={{ display: 'none' }}>Feature name is required</span>
                        </div>

                        {/* Description */}
                        <div className="form-group">
                            <label>Description</label>
                            <textarea
                                className="form-control required-field"
                                rows="3"
                                value={featureModel.description}
                                onChange={e => {
                                    this.setState({ featureModel: { ...featureModel, description: e.target.value } });
                                    this.hideValidationMessagesIfValid();
                                }}
                            />
                            <span className="form-error required text-danger" style={{ display: 'none' }}>Description is required</span>
                        </div>

                        {/* Color */}
                       <div className="form-group color-fix-wrapper">
                            <label>Color code</label>
                            <input
                                type="color"
                                className="form-control required-field color-picker-fix"
                                value={featureModel.colorCode}
                                onChange={e => {
                                    this.setState({ featureModel: { ...featureModel, colorCode: e.target.value } });
                                    this.hideValidationMessagesIfValid();
                                }}
                            />
                            <span className="form-error required text-danger" style={{ display: 'none' }}>
                                Color code is required
                            </span>
                        </div>


                        {/* Status */}
                        <div className="form-group">
                            <label>Status</label>
                            <Dropdown
                                className="required-field"
                                style={{ width: '100%' }}
                                filter
                                placeholder="-Select status-"
                                value={featureModel.status}
                                options={featureStatusList}
                                onChange={(e) => {
                                      const value = e.value;

                                          this.setState(
                                                   prevState => ({
                                                           featureModel: {
                                                          ...prevState.featureModel,
                                                             status: value
                                                                        }
                                                                }),
                                                                 () => {
                                                                      $('#addFeatureForm')
                                                                      .find('label:contains("Status")')
                                                                      .closest('.form-group')
                                                                      .find('.form-error.required')
                                                                       .hide();
                                                                       }
                                                      );
                                                }}
                            />
                            <span className="form-error required text-danger" style={{ display: 'none' }}>Status is required</span>
                        </div>

                        {/* Project */}
                        <div className="form-group">
                            <label>Project</label>
                            <Dropdown
                                            className="required-field"
                                            style={{ width: '100%' }}
                                            filter
                                            placeholder="-Select project-"
                                            value={featureModel.projectId}
                                            options={projects}
                                            onChange={(e) => {
                                                const value = e.value; 

                                                this.setState(
                                                    prevState => ({
                                                        featureModel: {
                                                            ...prevState.featureModel,
                                                            projectId: value
                                                        }
                                                    }),
                                                    () => {
                                                        
                                                        $('#addFeatureForm')
                                                            .find('label:contains("Project")')
                                                            .closest('.form-group')
                                                            .find('.form-error.required')
                                                            .hide();
                                                    }
                                                );
                                            }}
                                            disabled={featureModel.id !== 0}
                                        />

                            <span className="form-error required text-danger" style={{ display: 'none' }}>Project is required</span>
                        </div>

                        {(featureModel.id === 0 || canEditFeature) && (
                            <button
                                id="btnAddFeature"
                                type="button"
                                className="btn btn-primary w-100"
                                onClick={this.saveFeature}
                            >
                                Submit
                            </button>
                        )}


                        {featureModel.id !== 0 && canDeleteFeature && (
                                <button
                                    id="btnDeleteFeature"
                                    type="button"
                                    className="btn btn-danger w-100 mt-2"
                                    onClick={this.deleteFeatureById}
                                >
                                    Delete Feature
                                </button>
                            )}

                    </form>
                </div>
            </div>
        );
    }
}

export default AddFeature;